import axios from "axios";

const Axios = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}`,
  timeout: 10000,
  headers: {
    "Access-Control-Allow-Origin": "*",
    "Content-type": "application/json",
    authorization: window.localStorage.getItem("token"),
  },
});
export default Axios;
